import React from 'react'
import * as cnpjUtils from '@fnando/cnpj'
import { Box, Typography, Divider } from '@material-ui/core'
import { formatDate } from '~/utils/date'
import { transparentize } from 'polished'
import { mutualTheme } from '~/utils/theme'
import { makeStyles } from '@material-ui/styles'
import { CalendarIcon, DocumentIcon } from '~/assets/icons'
import { useAuthAccount } from '~/store/auth/useAuthAccount'
import { DocumentationOnboardStepsStatus, Bold } from '~/components'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: mutualTheme.spacing(5),
    backgroundColor: mutualTheme.palette.grey[300],
    height: '100%'
  },
  cnpj: {
    marginLeft: mutualTheme.spacing(1),
    color: transparentize(0.5, mutualTheme.palette.grey[500])
  },
  divider: {
    marginTop: mutualTheme.spacing(3),
    marginBottom: mutualTheme.spacing(3)
  },
  iconContainer: {
    display: 'flex',
    felxDirection: 'row',
    alignItems: 'center'
  }
})

export const DocumentationOnboardSidebar: React.FC = () => {
  const classes = useStyles()
  const { nickname, cnpj, createdAt } = useAuthAccount()

  return (
    <Box className={classes.container}>
      <Typography variant='airbnbH3' gutterBottom><Bold>{nickname}</Bold></Typography>
      <Box className={classes.iconContainer}>
        <DocumentIcon htmlColor={mutualTheme.palette.textGray2.main} height={24} width={24} />
        <Typography variant='airbnbBody1' className={classes.cnpj}>{cnpjUtils.format(cnpj)}</Typography>
      </Box>
      <Box sx={{ marginTop: 1 }} className={classes.iconContainer}>
        <CalendarIcon height={24} width={24} />
        <Typography variant='airbnbBody1' className={classes.cnpj}>Iniciada em {formatDate(createdAt)}</Typography>
      </Box>
      <Divider className={classes.divider} />
      <DocumentationOnboardStepsStatus />
    </Box>
  )
}
